import api from "@client/content/lib/api";
import { type ModuleApiInfo } from "@client/content/selectors";
import { type HttpApiResponse } from "@client/types/Api";
import { type MemberVerification } from "./types";

export default {
  init: (
    apiInfo: ModuleApiInfo,
    otp: string,
    scheduleId: string
  ): Promise<HttpApiResponse<MemberVerification.Api.Verification[]>> =>
    api.get(apiInfo, `/api/site/v1/modules/verification`, { otp, scheduleId }),
  verify: (
    apiInfo: ModuleApiInfo,
    id: string,
    args: MemberVerification.Api.VerificationRequest
  ): Promise<HttpApiResponse<MemberVerification.Api.VerificationResponse | null>> =>
    api.put(apiInfo, `/api/site/v1/modules/verification/${id}`, args)
};
